import { Stack, styled } from '@mui/material';

export const DateRangeStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  minWidth: '288px',
  height: '36px',
  padding: '0 8px',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: `1px solid`,
  borderRadius: '10px',
  borderColor: theme.palette.text.fourth,
}));
